import { Checkbox, type CheckboxProps } from '@progress/kendo-react-inputs'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import * as R from 'remeda'

import { type InputValues } from './utils'

type AllCheckboxProps = {
  enabledIndices: number[]
}

export const AllCheckbox = ({ enabledIndices }: AllCheckboxProps) => {
  const { setValue, trigger, watch } = useFormContext<InputValues>()

  const customerAttributes = watch('customerAttributes')
  const enabledAttributes = enabledIndices.map((i) => customerAttributes[i])

  const isCheckAll = enabledAttributes.every(R.prop('checked'))
  const isUncheckAll =
    enabledAttributes.every(R.isNot(R.prop('checked'))) ||
    enabledAttributes.length === 0

  const checked = isCheckAll ? true : isUncheckAll ? false : null

  const handleAllChange = React.useCallback<EH<CheckboxProps, 'onChange'>>(
    (event) => {
      setValue(
        'customerAttributes',
        customerAttributes.map((customerAttribute, index) =>
          enabledIndices.includes(index)
            ? { ...customerAttribute, checked: event.value }
            : customerAttribute,
        ),
      )
      trigger('customerAttributes')
    },
    [customerAttributes, enabledIndices, setValue, trigger],
  )

  return (
    <Checkbox
      checked={checked}
      disabled={enabledIndices.length === 0}
      onChange={handleAllChange}
    />
  )
}
